import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import { createRoot } from 'react-dom/client';
import StripePayment from 'src/components/domain/payment/StripePayment';
import { customizationAtom } from 'src/components/utils/theme/customizations';
import { MUITheme } from 'src/components/utils/theme/Theme';
import StripeAlertWidget from './StripeAlertWidget';
import StripePayButtonWidget from './StripePayButtonWidget';

StripePayButtonWidget();
StripeAlertWidget();

// Idempotent per host: called eagerly for the bilberry-checkout singleton at bundle init and
// lazily by every StripePaymentWrapper for its own host element. Slot projection only reaches
// direct children of the shadow host, so each host that renders a Stripe payment needs its own
// slotted form.
export function initStripePayment(parent: HTMLElement) {
    if (parent.querySelector(':scope > [slot="stripe-payment-slot"]')) {
        return;
    }

    const stripeMountPoint = document.createElement('div');
    stripeMountPoint.className = 'bilberry-stripe-payment';
    stripeMountPoint.slot = 'stripe-payment-slot';

    const customizations = customizationAtom.subject.value;

    const cache = createCache({
        key: 'css',
        prepend: true,
        container: stripeMountPoint,
    });

    createRoot(stripeMountPoint).render(
        <CacheProvider value={cache}>
            <ThemeProvider theme={MUITheme(customizations)}>
                <StripePayment />
            </ThemeProvider>
        </CacheProvider>,
    );

    parent.appendChild(stripeMountPoint);
}
